var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['text-counter', 'medium', 'regular', 'left-margin-15'],on:{"click":_vm.onClick}},[_c('span',{class:['icon', 'dark', _vm.state === 'off' ? 'trash' : 'check']})])}
var staticRenderFns = []

export { render, staticRenderFns }